var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import firebase from "firebase/app";
import "firebase/database";
import { FIREBASE_PUBLIC_WON_PROOF, FIREBASE_USERS_PRIVATE, FIREBASE_USERS_PUBLIC, FIREBASE_CUSTOM_QUESTS, } from "./defs";
/*
Here is firebase rules:

{
  "rules": {
    "usersPublic": {
      "$uid": {
        "info": {
          ".write": "$uid === auth.uid",
        },
        "gamesWonCount": {
          ".write": "$uid === auth.uid",
        },
        "gamesWonProofs": {
          "$gameName": {
            "$aleaSeed": {
              ".write": "$uid === auth.uid",
              ".validate": "newData.hasChild('created') && newData.child('created').val() === now && data.val() === null",
            }
          }
        }
      },
      ".read": true,
      ".indexOn": ["gamesWonCount"]
    },
     
    "usersPrivate": {
      "$uid": {
        ".write": "$uid === auth.uid",
        ".read": true,
      }
    },

    "customQuests": {
      "$user_id": {
        ".read": "$user_id === auth.uid",
        "$quest_name": {
          ".write": "$user_id === auth.uid",
          ".read": "$user_id === auth.uid || data.child('isPublic').val() == true",
        }
      }
    },
      
    "wonProofs": {
      "$proofId": {
        ".write": "newData.hasChild('userId') && newData.child('userId').val() === auth.uid && newData.hasChild('createdAt') && newData.child('createdAt').val() === now && ! newData.hasChild('validated')",
        ".validate": "data.val() == null",
        ".read": true,
      },
      ".indexOn": ["userId", "gameName", "aleaSeed"],
      ".read": true,
    }
  }
}


*/
var INDEXEDDB_NAME = "spaceranges2";
var INDEXEDDB_CONFIG_STORE_NAME = "config";
var INDEXEDDB_SAVED_STORE_NAME = "savedgames";
var INDEXEDDB_WON_STORE_NAME = "wongames";
var INDEXEDDB_CUSTOM_SAVED_STORE_NAME = "customsavedgames";
// export interface GameLogDatabase extends GameLog {
//   created: number;
// }
function debug() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    //console.info(...args);
}
export function getDb(app) {
    return __awaiter(this, void 0, void 0, function () {
        // await new Promise<void>(resolve => setTimeout(resolve, 1));
        function getLocal(storeName, key) {
            return __awaiter(this, void 0, void 0, function () {
                var trx, objectStore, getReq_1, localResult, raw;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!db) return [3 /*break*/, 2];
                            trx = db.transaction([storeName], "readonly");
                            objectStore = trx.objectStore(storeName);
                            getReq_1 = objectStore.get(key);
                            return [4 /*yield*/, new Promise(function (resolve, reject) {
                                    getReq_1.onsuccess = function (e) {
                                        resolve(getReq_1.result);
                                    };
                                    getReq_1.onerror = function (e) {
                                        return reject(new Error(getReq_1.error ? getReq_1.error.toString() : "Unknown"));
                                    };
                                })];
                        case 1:
                            localResult = _a.sent();
                            return [2 /*return*/, localResult];
                        case 2:
                            raw = localStorage.getItem("RANGERS-" + storeName + "-" + key);
                            if (raw) {
                                return [2 /*return*/, JSON.parse(raw)];
                            }
                            else {
                                return [2 /*return*/, null];
                            }
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        function getAllLocal(storeName) {
            return __awaiter(this, void 0, void 0, function () {
                var objectStore_1, prefix, r, _a, _b, lsFullKey, key, raw;
                var e_1, _c;
                return __generator(this, function (_d) {
                    if (db) {
                        objectStore_1 = db.transaction([storeName]).objectStore(storeName);
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                var data = {};
                                var openCursor = objectStore_1.openCursor();
                                openCursor.onsuccess = function (event) {
                                    var cursor = event.target.result;
                                    if (cursor) {
                                        if (cursor.value) {
                                            data[cursor.key] = cursor.value;
                                        }
                                        cursor.continue();
                                    }
                                    else {
                                        // alert("No more entries!");
                                        resolve(data);
                                    }
                                };
                                openCursor.onerror = function (e) {
                                    reject(new Error(openCursor.error ? openCursor.error.toString() : "Unknown"));
                                };
                            })];
                    }
                    else {
                        prefix = "RANGERS-" + storeName + "-";
                        r = {};
                        try {
                            for (_a = __values(Object.keys(localStorage)), _b = _a.next(); !_b.done; _b = _a.next()) {
                                lsFullKey = _b.value;
                                if (lsFullKey.indexOf(prefix) !== 0) {
                                    continue;
                                }
                                key = lsFullKey.slice(prefix.length);
                                raw = localStorage.getItem(lsFullKey);
                                if (raw) {
                                    r[key] = JSON.parse(raw);
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        return [2 /*return*/, r];
                    }
                    return [2 /*return*/];
                });
            });
        }
        function setLocal(storeName, key, value) {
            return __awaiter(this, void 0, void 0, function () {
                var trx, objectStore, req_1, lsFullKey;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!db) return [3 /*break*/, 2];
                            trx = db.transaction([storeName], "readwrite");
                            objectStore = trx.objectStore(storeName);
                            req_1 = value ? objectStore.put(value, key) : objectStore.delete(key);
                            return [4 /*yield*/, new Promise(function (resolve, reject) {
                                    req_1.onsuccess = function (e) { return resolve(); };
                                    req_1.onerror = function (e) {
                                        console.warn("Indexeddb error", req_1.error);
                                        reject(new Error(req_1.error ? "IndexedDB error: " + req_1.error.name + " " + req_1.error.message : "Unknown"));
                                    };
                                })];
                        case 1:
                            _a.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            lsFullKey = "RANGERS-" + storeName + "-" + key;
                            if (value) {
                                localStorage.setItem(lsFullKey, JSON.stringify(value));
                            }
                            else {
                                localStorage.removeItem(lsFullKey);
                            }
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        function firebaseGoOffline() {
            firebaseDatabaseOnlineConnections--;
            if (firebaseDatabaseOnlineConnections <= 0) {
                debug("Firebase goes offline, no consumers");
                try {
                    app.database().goOffline();
                }
                catch (e) {
                    console.warn("Error with firebase", e);
                }
            }
            else {
                debug("Firebase will not go offline, have " + firebaseDatabaseOnlineConnections + " consumers");
            }
        }
        function firebaseGoOnline() {
            firebaseDatabaseOnlineConnections++;
            if (firebaseDatabaseOnlineConnections === 1) {
                debug("We are the first firebase online consumer, going online");
                try {
                    app.database().goOnline();
                }
                catch (e) {
                    console.warn("Error with firebase", e);
                }
            }
            else {
                debug("Now firebase have " + firebaseDatabaseOnlineConnections + " connections");
            }
        }
        /* No actions from this point, only exported functions */
        function setFirebase(store, userId, userPath, value) {
            return __awaiter(this, void 0, void 0, function () {
                var targetUserId, fullRefPath, setResult, e_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 3, 4, 5]);
                            firebaseGoOnline();
                            targetUserId = userId || (firebaseUser ? firebaseUser.uid : null);
                            if (!targetUserId) return [3 /*break*/, 2];
                            fullRefPath = store + "/" + targetUserId + "/" + userPath;
                            debug("Firebase SET fullRefPath=" + fullRefPath + " value=" + JSON.stringify(value));
                            return [4 /*yield*/, Promise.race([
                                    app.database().ref(fullRefPath).set(value),
                                    new Promise(function (r) { return setTimeout(r, 60000); }).then(function () { return Promise.reject("Timed out"); }),
                                ])];
                        case 1:
                            setResult = _a.sent();
                            _a.label = 2;
                        case 2: return [3 /*break*/, 5];
                        case 3:
                            e_2 = _a.sent();
                            console.error("Error with firebase: ", e_2);
                            return [3 /*break*/, 5];
                        case 4:
                            firebaseGoOffline();
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        }
        function setFirebaseThisUser(store, userPath, value) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, setFirebase(store, undefined, userPath, value)];
                });
            });
        }
        function getFirebase(store, userId, userPath) {
            return __awaiter(this, void 0, void 0, function () {
                var firebaseResult, e_3;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, 3, 4]);
                            firebaseGoOnline();
                            return [4 /*yield*/, Promise.race([
                                    new Promise(function (resolve, reject) {
                                        var targetUserId = userId || (firebaseUser ? firebaseUser.uid : null);
                                        targetUserId
                                            ? app
                                                .database()
                                                .ref(store + "/" + targetUserId + "/" + userPath)
                                                .once("value", function (snapshot) {
                                                var value = snapshot ? snapshot.val() : null;
                                                debug("Firebase GET path=" + store + "/" + (firebaseUser ? firebaseUser.uid : "ERR") + "/" + userPath + " value=" + JSON.stringify(value));
                                                resolve(value);
                                            }, function (err) {
                                                reject(err);
                                            })
                                            : resolve(null);
                                    }),
                                    new Promise(function (r) { return setTimeout(function () { return r(null); }, 60000); }).then(function () {
                                        return Promise.reject("Firebase read timeout");
                                    }),
                                ])];
                        case 1:
                            firebaseResult = _a.sent();
                            return [2 /*return*/, firebaseResult];
                        case 2:
                            e_3 = _a.sent();
                            console.error("Error with firebase: ", e_3);
                            return [2 /*return*/, null];
                        case 3:
                            firebaseGoOffline();
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
        function getFirebaseThisUser(store, userPath) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, getFirebase(store, undefined, userPath)];
                });
            });
        }
        function setOwnHighscoresName(name) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, setFirebaseThisUser(FIREBASE_USERS_PUBLIC, "info/name", name)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
        function getFirebasePublicHighscores() {
            return __awaiter(this, void 0, void 0, function () {
                var data, e_4;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            firebaseGoOnline();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, 4, 5]);
                            return [4 /*yield*/, new Promise(function (resolve, reject) {
                                    var allUsersRef = app.database().ref(FIREBASE_USERS_PUBLIC);
                                    allUsersRef
                                        .orderByChild("gamesWonCount")
                                        .limitToLast(100)
                                        .once("value", function (snapshot) {
                                        if (snapshot) {
                                            var champions_1 = [];
                                            snapshot.forEach(function (champion) {
                                                champions_1.push(__assign(__assign({}, champion.val()), { userId: champion.key }));
                                                return undefined; // Typescript needs this for some unknown reasons
                                            });
                                            resolve(champions_1.reverse());
                                        }
                                        else {
                                            resolve(null);
                                        }
                                    })
                                        .catch(function (e) { return reject(e); });
                                })];
                        case 2:
                            data = _a.sent();
                            return [2 /*return*/, data];
                        case 3:
                            e_4 = _a.sent();
                            console.warn(e_4);
                            return [2 /*return*/, null];
                        case 4:
                            firebaseGoOffline();
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        }
        /*
          async function getLocalAndFirebase(storeName: string, key: string) {
              const localResult = await getLocal(storeName, key);
              debug(
                  `getLocal store=${storeName} key=${key} localResult=${JSON.stringify(
                      localResult
                  )}`
              );
              const firebaseResult = await getFirebase(
                  FIREBASE_USERS_PRIVATE,
                  `${storeName}/${key}`
              );
      
              if (firebaseResult !== undefined && firebaseResult !== null) {
                  debug(
                      `getFirebase store=${storeName} key=${key} firebaseResult=${JSON.stringify(
                          firebaseResult
                      )}`
                  );
                  await setLocal(storeName, key, firebaseResult);
                  return firebaseResult;
              }
              debug(
                  `getLocal store=${storeName} key=${key} no_firebase_result`
              );
              return localResult;
          }
          */
        function setConfigBoth(key, value) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            debug("setConfig key=" + key + " value=" + JSON.stringify(value));
                            return [4 /*yield*/, setLocal(INDEXEDDB_CONFIG_STORE_NAME, key, value)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, setFirebaseThisUser(FIREBASE_USERS_PRIVATE, INDEXEDDB_CONFIG_STORE_NAME + "/" + key, value)];
                        case 2:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
        function setConfigLocal(key, value) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            debug("setConfig key=" + key + " value=" + JSON.stringify(value));
                            return [4 /*yield*/, setLocal(INDEXEDDB_CONFIG_STORE_NAME, key, value)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
        // async function getBoth<T extends keyof Config>(key: T): Promise<Config[T] | null> {
        //    return getLocalAndFirebase(INDEXEDDB_CONFIG_STORE_NAME, key);
        //}
        function getConfigLocal(key) {
            return __awaiter(this, void 0, Promise, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, getLocal(INDEXEDDB_CONFIG_STORE_NAME, key)];
                });
            });
        }
        function firebaseOnline(f) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            firebaseGoOnline();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 3, 4]);
                            return [4 /*yield*/, f()];
                        case 2: return [2 /*return*/, _a.sent()];
                        case 3:
                            firebaseGoOffline();
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
        function getRemotePassings(userId) {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, firebaseOnline(function () { return __awaiter(_this, void 0, void 0, function () {
                                var ref, query, data;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            ref = app.database().ref(FIREBASE_PUBLIC_WON_PROOF);
                                            query = userId ? ref.orderByChild("userId").equalTo(userId) : ref;
                                            return [4 /*yield*/, query.once("value")];
                                        case 1:
                                            data = (_a.sent()).val();
                                            return [2 /*return*/, data];
                                    }
                                });
                            }); })];
                        case 1: 
                        /*
                    
                    store.app.database().goOnline();
                    const firebaseUser = store.app.auth().currentUser;
                    const FIREBASE_PUBLIC_WON_PROOF = 'wonProofs';
                    
                    (await store.app.database().ref("wonProofs").
                    orderByChild('createdAt').once("value")).val();
                    
                          */
                        return [2 /*return*/, _a.sent()];
                    }
                });
            });
        }
        function setRemoteWon(key, row) {
            return firebaseOnline(function () {
                return app
                    .database()
                    .ref(FIREBASE_PUBLIC_WON_PROOF + "/" + key)
                    .set(row);
            });
        }
        function updateFirebaseOwnHighscore() {
            return __awaiter(this, void 0, void 0, function () {
                var allRemotePrivateWons, newCount, newProofs, _a, _b, gameName, proofs, allRemotePublicWons, _c, _d, gameName, _e, _f, aleaSeed, gameLog, created, e_5_1, e_6_1, e_7;
                var e_8, _g, e_6, _h, e_5, _j;
                return __generator(this, function (_k) {
                    switch (_k.label) {
                        case 0:
                            _k.trys.push([0, 18, , 19]);
                            return [4 /*yield*/, getFirebaseThisUser(FIREBASE_USERS_PRIVATE, "" + INDEXEDDB_WON_STORE_NAME)];
                        case 1:
                            allRemotePrivateWons = (_k.sent()) || {};
                            newCount = 0;
                            newProofs = {};
                            try {
                                for (_a = __values(Object.keys(allRemotePrivateWons)), _b = _a.next(); !_b.done; _b = _a.next()) {
                                    gameName = _b.value;
                                    proofs = allRemotePrivateWons[gameName];
                                    if (!proofs || Object.keys(proofs).length < 1) {
                                        continue;
                                    }
                                    newProofs[gameName] = proofs;
                                    newCount++;
                                }
                            }
                            catch (e_8_1) { e_8 = { error: e_8_1 }; }
                            finally {
                                try {
                                    if (_b && !_b.done && (_g = _a.return)) _g.call(_a);
                                }
                                finally { if (e_8) throw e_8.error; }
                            }
                            return [4 /*yield*/, getFirebaseThisUser(FIREBASE_USERS_PUBLIC, "gamesWonProofs")];
                        case 2:
                            allRemotePublicWons = (_k.sent()) || {};
                            debug("Updating public highscores newCount=" + newCount);
                            return [4 /*yield*/, setFirebaseThisUser(FIREBASE_USERS_PUBLIC, "gamesWonCount", newCount)];
                        case 3:
                            _k.sent();
                            _k.label = 4;
                        case 4:
                            _k.trys.push([4, 15, 16, 17]);
                            _c = __values(Object.keys(newProofs)), _d = _c.next();
                            _k.label = 5;
                        case 5:
                            if (!!_d.done) return [3 /*break*/, 14];
                            gameName = _d.value;
                            _k.label = 6;
                        case 6:
                            _k.trys.push([6, 11, 12, 13]);
                            _e = (e_5 = void 0, __values(Object.keys(newProofs[gameName]))), _f = _e.next();
                            _k.label = 7;
                        case 7:
                            if (!!_f.done) return [3 /*break*/, 10];
                            aleaSeed = _f.value;
                            if (!(!allRemotePublicWons[gameName] || !allRemotePublicWons[gameName][aleaSeed])) return [3 /*break*/, 9];
                            gameLog = newProofs[gameName][aleaSeed];
                            created = firebase.database.ServerValue.TIMESTAMP;
                            debug("Updating firebase public won game=" + gameName + " seed=" + aleaSeed);
                            return [4 /*yield*/, setFirebaseThisUser(FIREBASE_USERS_PUBLIC, "gamesWonProofs/" + gameName + "/" + aleaSeed, __assign(__assign({}, gameLog), { created: created }))];
                        case 8:
                            _k.sent();
                            _k.label = 9;
                        case 9:
                            _f = _e.next();
                            return [3 /*break*/, 7];
                        case 10: return [3 /*break*/, 13];
                        case 11:
                            e_5_1 = _k.sent();
                            e_5 = { error: e_5_1 };
                            return [3 /*break*/, 13];
                        case 12:
                            try {
                                if (_f && !_f.done && (_j = _e.return)) _j.call(_e);
                            }
                            finally { if (e_5) throw e_5.error; }
                            return [7 /*endfinally*/];
                        case 13:
                            _d = _c.next();
                            return [3 /*break*/, 5];
                        case 14: return [3 /*break*/, 17];
                        case 15:
                            e_6_1 = _k.sent();
                            e_6 = { error: e_6_1 };
                            return [3 /*break*/, 17];
                        case 16:
                            try {
                                if (_d && !_d.done && (_h = _c.return)) _h.call(_c);
                            }
                            finally { if (e_6) throw e_6.error; }
                            return [7 /*endfinally*/];
                        case 17:
                            debug("Updating public highscores done");
                            return [3 /*break*/, 19];
                        case 18:
                            e_7 = _k.sent();
                            console.warn("public wining state sync error", e_7, e_7.stack);
                            return [3 /*break*/, 19];
                        case 19: return [2 /*return*/];
                    }
                });
            });
        }
        function syncWithFirebase() {
            return __awaiter(this, void 0, void 0, function () {
                var userId, _a, _b, key, firebaseResult, localResult, e_9_1, allLocalWons, allRemoteWons, allGameNames, allGameNames_1, allGameNames_1_1, gameName, thisGameLocalWons, thisGameRemoteWons, _c, _d, localSeed, localProof, e_10_1, _e, _f, remoteSeed, remoteProof, values, newValues, e_11_1, e_12_1, e_13, localConfig, rangerName, allLocalWons, allRemoteWons, _g, _h, gameName, proofs, _j, _k, aleaSeed, proof, e_14_1, e_15_1, _l, _m, aleaSeed, row, gameName, values, newValues, e_16_1, e_17, localName;
                var e_9, _o, e_12, _p, e_10, _q, e_11, _r, _s, e_15, _t, e_14, _u, e_16, _v, _w;
                return __generator(this, function (_x) {
                    switch (_x.label) {
                        case 0:
                            userId = firebaseUser ? firebaseUser.uid : undefined;
                            if (!userId) {
                                return [2 /*return*/];
                            }
                            firebaseGoOnline();
                            _x.label = 1;
                        case 1:
                            _x.trys.push([1, , 74, 75]);
                            debug("SyncWithFirebase started");
                            _x.label = 2;
                        case 2:
                            _x.trys.push([2, 12, 13, 14]);
                            _a = __values(["player", "lastPlayedGame", "noMusic"]), _b = _a.next();
                            _x.label = 3;
                        case 3:
                            if (!!_b.done) return [3 /*break*/, 11];
                            key = _b.value;
                            return [4 /*yield*/, getFirebaseThisUser(FIREBASE_USERS_PRIVATE, INDEXEDDB_CONFIG_STORE_NAME + "/" + key)];
                        case 4:
                            firebaseResult = _x.sent();
                            if (!firebaseResult) return [3 /*break*/, 6];
                            debug("Taking config " + key + " from firebase");
                            return [4 /*yield*/, setLocal(INDEXEDDB_CONFIG_STORE_NAME, key, firebaseResult)];
                        case 5:
                            _x.sent();
                            return [3 /*break*/, 10];
                        case 6:
                            if (!(firebaseResult === null)) return [3 /*break*/, 10];
                            return [4 /*yield*/, getLocal(INDEXEDDB_CONFIG_STORE_NAME, key)];
                        case 7:
                            localResult = _x.sent();
                            if (!localResult) return [3 /*break*/, 9];
                            debug("Saving firebase config " + key + " because there is nothing");
                            return [4 /*yield*/, setFirebaseThisUser(FIREBASE_USERS_PRIVATE, INDEXEDDB_CONFIG_STORE_NAME + "/" + key, localResult)];
                        case 8:
                            _x.sent();
                            return [3 /*break*/, 10];
                        case 9:
                            debug("Config key " + key + " no in local, neither in firebase");
                            _x.label = 10;
                        case 10:
                            _b = _a.next();
                            return [3 /*break*/, 3];
                        case 11: return [3 /*break*/, 14];
                        case 12:
                            e_9_1 = _x.sent();
                            e_9 = { error: e_9_1 };
                            return [3 /*break*/, 14];
                        case 13:
                            try {
                                if (_b && !_b.done && (_o = _a.return)) _o.call(_a);
                            }
                            finally { if (e_9) throw e_9.error; }
                            return [7 /*endfinally*/];
                        case 14:
                            debug("Sync syncWithFirebase config done");
                            _x.label = 15;
                        case 15:
                            _x.trys.push([15, 40, , 41]);
                            debug("Sync old syncWithFirebase passed games started");
                            return [4 /*yield*/, getAllLocal(INDEXEDDB_WON_STORE_NAME)];
                        case 16:
                            allLocalWons = _x.sent();
                            return [4 /*yield*/, getFirebaseThisUser(FIREBASE_USERS_PRIVATE, "" + INDEXEDDB_WON_STORE_NAME)];
                        case 17:
                            allRemoteWons = (_x.sent()) || {};
                            allGameNames = Object.keys(__assign(__assign({}, allLocalWons), allRemoteWons));
                            _x.label = 18;
                        case 18:
                            _x.trys.push([18, 37, 38, 39]);
                            allGameNames_1 = __values(allGameNames), allGameNames_1_1 = allGameNames_1.next();
                            _x.label = 19;
                        case 19:
                            if (!!allGameNames_1_1.done) return [3 /*break*/, 36];
                            gameName = allGameNames_1_1.value;
                            thisGameLocalWons = allLocalWons[gameName] || {};
                            thisGameRemoteWons = allRemoteWons[gameName] || {};
                            _x.label = 20;
                        case 20:
                            _x.trys.push([20, 25, 26, 27]);
                            _c = (e_10 = void 0, __values(Object.keys(thisGameLocalWons))), _d = _c.next();
                            _x.label = 21;
                        case 21:
                            if (!!_d.done) return [3 /*break*/, 24];
                            localSeed = _d.value;
                            localProof = thisGameLocalWons[localSeed];
                            if (!localProof) {
                                return [3 /*break*/, 23];
                            }
                            if (!!thisGameRemoteWons[localSeed]) return [3 /*break*/, 23];
                            debug("Sync with firebase: gameName=" + gameName + " pushing seed=" + localSeed + " into firebase");
                            return [4 /*yield*/, setFirebaseThisUser(FIREBASE_USERS_PRIVATE, INDEXEDDB_WON_STORE_NAME + "/" + gameName + "/" + localSeed, localProof)];
                        case 22:
                            _x.sent();
                            _x.label = 23;
                        case 23:
                            _d = _c.next();
                            return [3 /*break*/, 21];
                        case 24: return [3 /*break*/, 27];
                        case 25:
                            e_10_1 = _x.sent();
                            e_10 = { error: e_10_1 };
                            return [3 /*break*/, 27];
                        case 26:
                            try {
                                if (_d && !_d.done && (_q = _c.return)) _q.call(_c);
                            }
                            finally { if (e_10) throw e_10.error; }
                            return [7 /*endfinally*/];
                        case 27:
                            _x.trys.push([27, 33, 34, 35]);
                            _e = (e_11 = void 0, __values(Object.keys(thisGameRemoteWons))), _f = _e.next();
                            _x.label = 28;
                        case 28:
                            if (!!_f.done) return [3 /*break*/, 32];
                            remoteSeed = _f.value;
                            remoteProof = thisGameRemoteWons[remoteSeed];
                            if (!remoteProof) {
                                return [3 /*break*/, 31];
                            }
                            if (!!thisGameLocalWons[remoteSeed]) return [3 /*break*/, 31];
                            debug("Sync with firebase: gameName=" + gameName + " fetching seed=" + remoteSeed + " from firebase");
                            return [4 /*yield*/, getLocal(INDEXEDDB_WON_STORE_NAME, gameName)];
                        case 29:
                            values = _x.sent();
                            newValues = __assign(__assign({}, values), (_s = {}, _s[remoteProof.aleaSeed] = remoteProof, _s));
                            return [4 /*yield*/, setLocal(INDEXEDDB_WON_STORE_NAME, gameName, newValues)];
                        case 30:
                            _x.sent();
                            _x.label = 31;
                        case 31:
                            _f = _e.next();
                            return [3 /*break*/, 28];
                        case 32: return [3 /*break*/, 35];
                        case 33:
                            e_11_1 = _x.sent();
                            e_11 = { error: e_11_1 };
                            return [3 /*break*/, 35];
                        case 34:
                            try {
                                if (_f && !_f.done && (_r = _e.return)) _r.call(_e);
                            }
                            finally { if (e_11) throw e_11.error; }
                            return [7 /*endfinally*/];
                        case 35:
                            allGameNames_1_1 = allGameNames_1.next();
                            return [3 /*break*/, 19];
                        case 36: return [3 /*break*/, 39];
                        case 37:
                            e_12_1 = _x.sent();
                            e_12 = { error: e_12_1 };
                            return [3 /*break*/, 39];
                        case 38:
                            try {
                                if (allGameNames_1_1 && !allGameNames_1_1.done && (_p = allGameNames_1.return)) _p.call(allGameNames_1);
                            }
                            finally { if (e_12) throw e_12.error; }
                            return [7 /*endfinally*/];
                        case 39: return [3 /*break*/, 41];
                        case 40:
                            e_13 = _x.sent();
                            console.warn("wining state sync error", e_13, e_13.stack);
                            return [3 /*break*/, 41];
                        case 41:
                            debug("Sync old syncWithFirebase passed games done");
                            debug("Sync flat syncWithFirebase passed games started");
                            return [4 /*yield*/, getConfigLocal("player")];
                        case 42:
                            localConfig = _x.sent();
                            rangerName = localConfig ? localConfig.Ranger : "";
                            _x.label = 43;
                        case 43:
                            _x.trys.push([43, 68, , 69]);
                            return [4 /*yield*/, getAllLocal(INDEXEDDB_WON_STORE_NAME)];
                        case 44:
                            allLocalWons = (_x.sent());
                            return [4 /*yield*/, getRemotePassings(userId)];
                        case 45:
                            allRemoteWons = (_x.sent()) || {};
                            _x.label = 46;
                        case 46:
                            _x.trys.push([46, 57, 58, 59]);
                            _g = __values(Object.keys(allLocalWons)), _h = _g.next();
                            _x.label = 47;
                        case 47:
                            if (!!_h.done) return [3 /*break*/, 56];
                            gameName = _h.value;
                            proofs = allLocalWons[gameName];
                            _x.label = 48;
                        case 48:
                            _x.trys.push([48, 53, 54, 55]);
                            _j = (e_14 = void 0, __values(Object.keys(proofs))), _k = _j.next();
                            _x.label = 49;
                        case 49:
                            if (!!_k.done) return [3 /*break*/, 52];
                            aleaSeed = _k.value;
                            proof = proofs[aleaSeed];
                            if (!!allRemoteWons[aleaSeed]) return [3 /*break*/, 51];
                            debug("Pushing " + aleaSeed + " into remote wons");
                            return [4 /*yield*/, setRemoteWon(aleaSeed, {
                                    rangerName: rangerName,
                                    createdAt: firebase.database.ServerValue.TIMESTAMP,
                                    gameName: gameName,
                                    proof: proof,
                                    userId: userId,
                                })];
                        case 50:
                            _x.sent();
                            _x.label = 51;
                        case 51:
                            _k = _j.next();
                            return [3 /*break*/, 49];
                        case 52: return [3 /*break*/, 55];
                        case 53:
                            e_14_1 = _x.sent();
                            e_14 = { error: e_14_1 };
                            return [3 /*break*/, 55];
                        case 54:
                            try {
                                if (_k && !_k.done && (_u = _j.return)) _u.call(_j);
                            }
                            finally { if (e_14) throw e_14.error; }
                            return [7 /*endfinally*/];
                        case 55:
                            _h = _g.next();
                            return [3 /*break*/, 47];
                        case 56: return [3 /*break*/, 59];
                        case 57:
                            e_15_1 = _x.sent();
                            e_15 = { error: e_15_1 };
                            return [3 /*break*/, 59];
                        case 58:
                            try {
                                if (_h && !_h.done && (_t = _g.return)) _t.call(_g);
                            }
                            finally { if (e_15) throw e_15.error; }
                            return [7 /*endfinally*/];
                        case 59:
                            _x.trys.push([59, 65, 66, 67]);
                            _l = __values(Object.keys(allRemoteWons)), _m = _l.next();
                            _x.label = 60;
                        case 60:
                            if (!!_m.done) return [3 /*break*/, 64];
                            aleaSeed = _m.value;
                            row = allRemoteWons[aleaSeed];
                            if (row.userId !== userId) {
                                throw new Error("Unexpected userId " + row.userId + ", expected " + userId);
                            }
                            gameName = row.gameName;
                            return [4 /*yield*/, getLocal(INDEXEDDB_WON_STORE_NAME, gameName)];
                        case 61:
                            values = (_x.sent()) || {};
                            if (!!values[aleaSeed]) return [3 /*break*/, 63];
                            debug("Polling " + aleaSeed + " from remote wons");
                            newValues = __assign(__assign({}, values), (_w = {}, _w[aleaSeed] = row.proof, _w));
                            return [4 /*yield*/, setLocal(INDEXEDDB_WON_STORE_NAME, gameName, newValues)];
                        case 62:
                            _x.sent();
                            _x.label = 63;
                        case 63:
                            _m = _l.next();
                            return [3 /*break*/, 60];
                        case 64: return [3 /*break*/, 67];
                        case 65:
                            e_16_1 = _x.sent();
                            e_16 = { error: e_16_1 };
                            return [3 /*break*/, 67];
                        case 66:
                            try {
                                if (_m && !_m.done && (_v = _l.return)) _v.call(_l);
                            }
                            finally { if (e_16) throw e_16.error; }
                            return [7 /*endfinally*/];
                        case 67: return [3 /*break*/, 69];
                        case 68:
                            e_17 = _x.sent();
                            console.warn("wining state sync error", e_17, e_17.stack);
                            return [3 /*break*/, 69];
                        case 69:
                            debug("Sync flat syncWithFirebase passed games done");
                            return [4 /*yield*/, updateFirebaseOwnHighscore()];
                        case 70:
                            _x.sent();
                            debug("Own highscores synced");
                            return [4 /*yield*/, getConfigLocal("player")];
                        case 71:
                            localName = _x.sent();
                            if (!localName) return [3 /*break*/, 73];
                            return [4 /*yield*/, setOwnHighscoresName(localName.Ranger || "")];
                        case 72:
                            _x.sent();
                            _x.label = 73;
                        case 73:
                            debug("Public ranger name synced");
                            debug("Sync with firebase finished");
                            return [3 /*break*/, 75];
                        case 74:
                            firebaseGoOffline();
                            return [7 /*endfinally*/];
                        case 75: return [2 /*return*/];
                    }
                });
            });
        }
        function isGamePassedLocal(gameName) {
            return __awaiter(this, void 0, void 0, function () {
                var values;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, getLocal(INDEXEDDB_WON_STORE_NAME, gameName)];
                        case 1:
                            values = _a.sent();
                            if (values && typeof values === "object" && Object.keys(values).length >= 1) {
                                return [2 /*return*/, values];
                            }
                            else {
                                return [2 /*return*/, false];
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
        function setGamePassing(gameName, proof) {
            return __awaiter(this, void 0, void 0, function () {
                var values, newValues, localConfig, rangerName, userId;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, getLocal(INDEXEDDB_WON_STORE_NAME, gameName)];
                        case 1:
                            values = _b.sent();
                            newValues = __assign(__assign({}, values), (_a = {}, _a[proof.aleaSeed] = proof, _a));
                            return [4 /*yield*/, setLocal(INDEXEDDB_WON_STORE_NAME, gameName, newValues)];
                        case 2:
                            _b.sent();
                            return [4 /*yield*/, setFirebaseThisUser(FIREBASE_USERS_PRIVATE, INDEXEDDB_WON_STORE_NAME + "/" + gameName + "/" + proof.aleaSeed, proof)];
                        case 3:
                            _b.sent();
                            return [4 /*yield*/, getConfigLocal("player")];
                        case 4:
                            localConfig = _b.sent();
                            rangerName = localConfig ? localConfig.Ranger : "";
                            userId = firebaseUser ? firebaseUser.uid : undefined;
                            if (!userId) return [3 /*break*/, 6];
                            return [4 /*yield*/, setRemoteWon(proof.aleaSeed, {
                                    rangerName: rangerName,
                                    createdAt: firebase.database.ServerValue.TIMESTAMP,
                                    gameName: gameName,
                                    proof: proof,
                                    userId: userId,
                                })];
                        case 5:
                            _b.sent();
                            _b.label = 6;
                        case 6: return [4 /*yield*/, updateFirebaseOwnHighscore()];
                        case 7:
                            _b.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
        function saveGame(gameName, saving) {
            return __awaiter(this, void 0, void 0, function () {
                var savingRaw;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            savingRaw = saving ? JSON.stringify(saving) : saving;
                            return [4 /*yield*/, setLocal(INDEXEDDB_SAVED_STORE_NAME, gameName, savingRaw)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
        function getLocalSaving(gameName) {
            return __awaiter(this, void 0, void 0, function () {
                var rawValue, value;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, getLocal(INDEXEDDB_SAVED_STORE_NAME, gameName)];
                        case 1:
                            rawValue = _a.sent();
                            try {
                                value = JSON.parse(rawValue);
                                return [2 /*return*/, value];
                            }
                            catch (e) {
                                return [2 /*return*/, null];
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
        /*
          async function getAllRemoteSavings(gameName: string) {
              const rawValue = await getFirebase(
                  FIREBASE_USERS_PRIVATE,
                  `${INDEXEDDB_SAVED_STORE_NAME}/${gameName}`
              );
              let value: {
                  [uid: string]: GameState;
              } = {};
              try {
                  for (const uid of Object.keys(rawValue)) {
                      value[uid] = JSON.parse(rawValue[uid]);
                  }
                  return value;
              } catch (e) {
                  return null;
              }
          }
          */
        function saveCustomQuest(questName, data) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, setFirebaseThisUser(FIREBASE_CUSTOM_QUESTS, "" + encodeURIComponent(questName), data
                                ? __assign(__assign({}, data), { updatedAt: firebase.database.ServerValue.TIMESTAMP }) : null)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
        function loadCustomQuest(targetUserId, questName) {
            return __awaiter(this, void 0, Promise, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, getFirebase(FIREBASE_CUSTOM_QUESTS, targetUserId, "" + encodeURIComponent(questName))];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        }
        function getAllMyCustomQuests() {
            return __awaiter(this, void 0, Promise, function () {
                var data, e_18;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            firebaseGoOnline();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, 4, 5]);
                            return [4 /*yield*/, new Promise(function (resolve, reject) {
                                    if (!firebaseUser) {
                                        resolve(null);
                                        return;
                                    }
                                    var allMyCustomQuests = app
                                        .database()
                                        .ref(FIREBASE_CUSTOM_QUESTS + "/" + firebaseUser.uid);
                                    allMyCustomQuests
                                        //.orderByChild("gamesWonCount")
                                        //.limitToLast(100)
                                        .once("value", function (snapshot) {
                                        if (snapshot) {
                                            var data_1 = snapshot.val();
                                            if (!data_1 || typeof data_1 !== "object") {
                                                resolve(null);
                                            }
                                            else {
                                                var transformedData_1 = {};
                                                Object.entries(data_1).forEach(function (_a) {
                                                    var _b = __read(_a, 2), key = _b[0], value = _b[1];
                                                    transformedData_1[decodeURIComponent(key)] = value;
                                                });
                                                debug(data_1, transformedData_1);
                                                resolve(transformedData_1);
                                            }
                                        }
                                        else {
                                            resolve(null);
                                        }
                                    })
                                        .catch(function (e) { return reject(e); });
                                })];
                        case 2:
                            data = _a.sent();
                            return [2 /*return*/, data];
                        case 3:
                            e_18 = _a.sent();
                            console.warn(e_18);
                            return [2 /*return*/, null];
                        case 4:
                            firebaseGoOffline();
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        }
        function getMyUserId() {
            return firebaseUser ? firebaseUser.uid : null;
        }
        function saveCustomGame(gameKey, saving) {
            return __awaiter(this, void 0, void 0, function () {
                var savingRaw;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            savingRaw = saving ? JSON.stringify(saving) : saving;
                            return [4 /*yield*/, setLocal(INDEXEDDB_CUSTOM_SAVED_STORE_NAME, gameKey, savingRaw)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
        function loadCustomGame(gameKey) {
            return __awaiter(this, void 0, void 0, function () {
                var rawValue, value;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, getLocal(INDEXEDDB_CUSTOM_SAVED_STORE_NAME, gameKey)];
                        case 1:
                            rawValue = _a.sent();
                            if (!rawValue) {
                                return [2 /*return*/, null];
                            }
                            try {
                                value = JSON.parse(rawValue);
                                return [2 /*return*/, value];
                            }
                            catch (e) {
                                return [2 /*return*/, null];
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
        var db, _a, firebaseUser, firebaseDatabaseOnlineConnections;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    debug("Starting to get db");
                    if (!window.indexedDB) return [3 /*break*/, 2];
                    return [4 /*yield*/, new Promise(function (resolve, reject) {
                            var idb = window.indexedDB.open(INDEXEDDB_NAME, 8);
                            debug("idb opened");
                            idb.onerror = function (e) {
                                return reject(new Error(idb.error ? "IndexedDB error: " + idb.error.name + " " + idb.error.message : "Unknown"));
                            };
                            idb.onsuccess = function (e) { return resolve(e.target.result); };
                            idb.onupgradeneeded = function (e) {
                                var e_19, _a;
                                debug("onupgradeneeded");
                                var db = e.target.result;
                                try {
                                    // debug(`Old version=${db.}`)
                                    for (var _b = __values([
                                        INDEXEDDB_CONFIG_STORE_NAME,
                                        INDEXEDDB_SAVED_STORE_NAME,
                                        INDEXEDDB_WON_STORE_NAME,
                                        INDEXEDDB_CUSTOM_SAVED_STORE_NAME,
                                    ]), _c = _b.next(); !_c.done; _c = _b.next()) {
                                        var storeName = _c.value;
                                        if (!db.objectStoreNames.contains(storeName)) {
                                            debug("Creating " + storeName + " store");
                                            db.createObjectStore(storeName, {
                                                // keyPath: false,
                                                autoIncrement: false,
                                            });
                                        }
                                        else {
                                            debug("It containt " + storeName + " store");
                                        }
                                    }
                                }
                                catch (e_19_1) { e_19 = { error: e_19_1 }; }
                                finally {
                                    try {
                                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                                    }
                                    finally { if (e_19) throw e_19.error; }
                                }
                            };
                        })];
                case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = undefined;
                    _b.label = 3;
                case 3:
                    db = _a;
                    debug(db ? "Got indexedDB" : "IndexedDB is not available, will use localStorage");
                    firebaseDatabaseOnlineConnections = 1;
                    try {
                        app.auth().onAuthStateChanged(function (user) {
                            firebaseUser = user;
                            debug("on auth changed = " + (firebaseUser ? firebaseUser.uid : "<null>"));
                        });
                        app
                            .database()
                            .ref(".info/connected")
                            .on("value", function (snap) {
                            var firebaseOnline = snap && snap.val();
                            debug("Firebase online=" + firebaseOnline);
                        });
                        firebaseGoOffline();
                    }
                    catch (e) {
                        console.error("Error with firebase: ", e);
                    }
                    debug("Returning db instance");
                    return [2 /*return*/, {
                            setConfigBoth: setConfigBoth,
                            setConfigLocal: setConfigLocal,
                            getConfigLocal: getConfigLocal,
                            isGamePassedLocal: isGamePassedLocal,
                            setGamePassing: setGamePassing,
                            getFirebasePublicHighscores: getFirebasePublicHighscores,
                            saveGame: saveGame,
                            getLocalSaving: getLocalSaving,
                            // getAllRemoteSavings,
                            syncWithFirebase: syncWithFirebase,
                            setOwnHighscoresName: setOwnHighscoresName,
                            getRemotePassings: getRemotePassings,
                            getAllMyCustomQuests: getAllMyCustomQuests,
                            saveCustomQuest: saveCustomQuest,
                            loadCustomQuest: loadCustomQuest,
                            getMyUserId: getMyUserId,
                            saveCustomGame: saveCustomGame,
                            loadCustomGame: loadCustomGame,
                        }];
            }
        });
    });
}
//# sourceMappingURL=data:application/json;base64,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